import { render, staticRenderFns } from "./aboutmy.vue?vue&type=template&id=8e3642ce&scoped=true&"
import script from "./aboutmy.vue?vue&type=script&lang=js&"
export * from "./aboutmy.vue?vue&type=script&lang=js&"
import style0 from "./aboutmy.vue?vue&type=style&index=0&id=8e3642ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3642ce",
  null
  
)

export default component.exports